module.exports = __webpack_public_path__ + "static/media/YANG MING.42d3f799.svg";